import { useEffect } from 'react';

import { onHover } from 'services/eventBus/hoverBus';

import classes from 'components/Dashboards/Reporting/widgetInReport/WidgetInReport.module.scss';

interface Params {
    containerRef: React.RefObject<HTMLElement>;
    widgetId: number;
    relationsMap: Map<number, Set<number>>;
}

export function useHighlightNarrativeRelationOnHover({ containerRef, widgetId, relationsMap }: Params) {
    // Listen to global hover events
    // if the hovered widget is related via the narrative relation map highlight it
    // direct DOM manipulation (not React state) to avoid unnecessary re-renders and scale better.

    useEffect(() => {
        const containerElement = containerRef.current;
        if (!containerElement) return;

        const relatedSet = relationsMap.get(widgetId);

        // Subscribe to onHover listener.
        // onHover return clean function that later cleaned on unmount or deps change.
        const unsubscribe = onHover(({ hoveredWidgetId }) => {
            const shouldHighlight = hoveredWidgetId != null && relatedSet?.has(hoveredWidgetId) === true;
            containerElement.classList.toggle(classes.highlight, shouldHighlight);
        });

        return () => {
            // cleanup subscription
            if (typeof unsubscribe === 'function') unsubscribe();
            // remove CSS to avoid stale state
            containerElement.classList.remove(classes.highlight);
        };
    }, [containerRef, widgetId, relationsMap]);
}
